"use strict";

window.addEventListener('DOMContentLoaded', () => {
  if (window.upscoreParameters) {
    window.sendArticleUpscoreData(window.upscoreParameters);
  } else {
    console.warn('[UpScore] The `upscoreParameters` variable not found in `window` ' + 'so data is not prepared and sent to UpScore tracker.');
  }
});